<div>
  <p class="notification__content">
    <span [ngClass]="data.icon + ' mat-notification-foreground'"></span>{{ data.message }}
  </p>
<span class="es-icon es-icon-close" (click)="dismissSnackbar()"></span>
</div>
